/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
import logger from './logger'

function createFetch(fetch, { useragent, cookie, ie }, sessionData) {
  if (ie) {
    return url => (
      new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            try {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                  json: () => JSON.parse(xhr.responseText),
                })
              }
              reject()
            } catch (e) {
              reject(e)
            }
          }
        }
        xhr.open('GET', url)
        xhr.setRequestHeader('Content-type', 'application/json')
        // xhr.setRequestHeader('Accept', 'application/json')
        // console.log('set timeout')
        xhr.timeout = 8000
        xhr.send(null);
      },
    ))
  }

  const options = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    credentials: 'include',
    mode: 'cors',
  };
  const headers = Object.assign({}, options.headers);
  if (!process.env.BROWSER) {
    headers['user-agent'] = useragent;
    if (options.credentials === 'include') {
      headers.cookie = cookie;
    }
  }
  return (url) => {
    if (!process.env.BROWSER) {
      logger.profile(`fetch ${url}`)
    }
    const req = fetch(url, Object.assign({}, options, {
      headers,
    }))
    return req.then((res) => {
      if (!process.env.BROWSER) {
        logger.profile(`fetch ${url}`)
      }
      // console.log(res.headers.get('set-cookie'))
      // console.log(sessionData)
      // eslint-disable-next-line
      if (sessionData && res.headers && res.headers._headers) sessionData.cookieArray = res.headers._headers['set-cookie']
      return res
    })
  }
}

export default createFetch;



// WEBPACK FOOTER //
// ./src/core/createFetch.js